/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import _ from 'underscore';

function isExplore(selection) {
	if (selection) {
		const foundInvalid = selection.some(item => {
			// The item must be an explore type.
			if ((item.tags || []).indexOf('explore') === -1) {
				return true;
			}

			// The item must be either module or uploaded File
			if (['exploration', 'page_asset'].indexOf(item.type) === -1) {
				return true;
			}

			// The item must have read permission
			const aPerm = ['read', 'execute'];
			if (_.intersection(item.permissions, aPerm).length < aPerm.length) {
				return true;
			}

			// The item must not be disabled
			if (item.disabled && item.disabled.toString().toLowerCase() === 'true') {
				return true;
			}

			return false;
		});

		return !foundInvalid;
	}
	return false;
}

export {
	isExplore
};



// WEBPACK FOOTER //
// ./src/js/util/AssetUtil.js